import { QuizResult } from './QuizRun.tsx';
import { EventParams } from '../../MathFactsGenerator/worksheetEventParams.ts';

/*
 * The parameters for the `quiz_completed` event in ADR 0026 §2.
 *
 * A pure function rather than an inline object in QuizPage, for the same reason
 * worksheetEventParams is one: the interesting part - deriving the mode and
 * sending duration_ms only when there is one - is worth a test, and reaching
 * handleFinish through a rendered quiz would cost a whole simulated run to
 * assert two fields.
 */
export function quizEventParams(operation: string, result: QuizResult): EventParams {
    const timed = result.durationMs !== null;

    return {
        operation,
        correct: result.correct,
        wrong: result.wrong,
        skipped: result.skipped,
        mode: timed ? 'timed' : 'untimed',
        // A 30-second run and a 3-minute run are not comparable without it, and
        // `mode` alone does not say which this was. Omitted entirely when
        // untimed rather than sent as null, which GA4 would drop anyway.
        ...(timed ? { duration_ms: result.durationMs as number } : {}),
    };
}

export default quizEventParams;
